import api from "../../api/api";

// delete module
export const deletePptModule = async (moduleId) =>
  await api.delete(`deleteModule/${moduleId}`);

//update module
export const updatePptModule = async (data) =>
  await api.patch(`updateModule/`, data);

//create module
export const createAssessmentModule = async (data) =>
  await api.post(`createNewModule`, data);

//create subModule
export const createPptSubModule = async (data) =>
  await api.post(`createNewSubmodule`, data);
//update subModules
export const updatePptSubModule = async (data) =>
  await api.patch(`updateSubModule`, data);
//delete subModules
export const deletePptSubModule = async (submoduleId) =>
  await api.delete(`deleteSubModule/${submoduleId}`);

//create Topic
export const createPptTopic = async (data) =>
  await api.post(`createNewTopic`, data);
//update Topic
export const updatePptTopic = async (data) =>
  await api.patch(`updateTopic/`, data);
//delete Topic
export const deletePptTopic = async (topicId) =>
  await api.delete(`deleteTopic/${topicId}`);
